/**
 * AI Provider Factory
 */

import type { AIProvider, AIProviderConfig } from '../types'
import { validateProviderConfig } from '../utils/validation'
import { OpenAIProvider } from '../providers/openai/OpenAIProvider'
import { AnthropicProvider } from '../providers/anthropic/AnthropicProvider'
import { GoogleProvider } from '../providers/google/GoogleProvider'
import { OpenRouterProvider } from '../providers/openrouter/OpenRouterProvider'
import { MockProvider } from '../providers/mock/MockProvider'

export class AIProviderFactory {
  static async create(config: AIProviderConfig): Promise<AIProvider> {
    // Validate configuration
    const validation = validateProviderConfig(config)
    if (!validation.valid) {
      throw new Error(validation.error)
    }
    
    switch (config.provider) {
      case 'openai':
        return new OpenAIProvider(config.apiKey!, config.model)
      
      case 'anthropic':
        return new AnthropicProvider(config.apiKey!, config.model)
      
      case 'google':
        return new GoogleProvider(config.apiKey!, config.model)
      
      case 'upstage':
        // Lazy load Upstage provider
        const { UpstageProvider } = await import('../providers/upstage/UpstageProvider')
        return new UpstageProvider(config.apiKey!, config.model)
      
      case 'openrouter':
        return new OpenRouterProvider(config.proxyUrl!, config.model)
      
      case 'mock':
      default:
        return new MockProvider()
    }
  }
}